// ABOUTME: Reads the first node id a link content type of a node points to.
// ABOUTME: Shared by the widgets' detailPage navigation and the catalog PDP dialog (prototype -> model).

interface LinkContent {
    contentType: string;
    value?: Array<{ value?: unknown[] | null } | null> | null;
}

export function readFirstLinkedNodeId(
    contents: readonly LinkContent[] | null | undefined,
    linkContentType: string,
): string | undefined {
    const raw = contents?.find(content => content.contentType === linkContentType)?.value?.[0]
        ?.value?.[0];
    // A link value is either a bare id or an object carrying one (see readLinkedNodeIds).
    const value = typeof raw === 'object' && raw !== null ? (raw as { id?: unknown }).id : raw;
    return typeof value === 'string' && value ? value : undefined;
}
